import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=2b973bb6&scoped=true&"
import script from "./AddModal.vue?vue&type=script&lang=js&"
export * from "./AddModal.vue?vue&type=script&lang=js&"
import style0 from "./AddModal.vue?vue&type=style&index=0&id=2b973bb6&prod&lang=css&"
import style1 from "./AddModal.vue?vue&type=style&index=1&id=2b973bb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b973bb6",
  null
  
)

export default component.exports